export enum PartnerTypesCode {
    Agent = "AG",
    Customer = "CS",
    Owner = "OW"
}